import InvoicesWalkthrough from './InvoicesWalkthrough';
export default InvoicesWalkthrough;